import { createFileRoute, redirect } from '@tanstack/react-router';

import { DEFAULT_REDIRECT_URL, REDIRECT_URL_KEY } from '@/constants';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const redirectUrl = sessionStorage.getItem(REDIRECT_URL_KEY) ?? DEFAULT_REDIRECT_URL;
    throw redirect({ to: redirectUrl });
  },
});
